export const REPLAY_AUDIT_KINDS = [
    "pause",
    "resume",
    "visibility-loss",
    "input-reset",
    "abandonment",
];
/** Audit-only lifecycle data, deliberately outside ReplayEnvelopeV1. */
export class AttemptAudit {
    attemptId;
    markers = [];
    constructor(attemptId) {
        this.attemptId = attemptId;
    }
    record(kind, tick) {
        if (!Number.isSafeInteger(tick) || tick < 0) {
            throw new Error("Audit tick must be non-negative");
        }
        this.markers.push({ kind, tick });
    }
    snapshot(attemptId = this.attemptId) {
        return {
            attemptId,
            markers: this.markers.map((marker) => ({ ...marker })),
        };
    }
}
